/**
 * Icon Tab
 */
angular.module('elogbooksDirectives').directive('iconTab', [
    '$rootScope',
    'modulesService',
    function ($rootScope, modulesService) {
    return {
        restrict: 'AE',
        replace: true,
        scope: {
            tabTitle: '@',
            tabIcon: '@',
            stateName: '@',
            sref: '@',
            stateCheck: '@',
            module: '@',
            disabled: '=?',
            disabledTooltip: '@'
        },
        templateUrl: '/modules/directives/layout/icon-tab/icon-tab.html',
        link: function($scope, $element) {
            if ($scope.module) {
                !modulesService.isEnabled($scope.module) ? $element.remove() : null;
            }

            // Monitor state change so correct tab can be set active
            $scope.stateName = $scope.$root.currentState;

            // The state to check to maker active
            $scope.stateCheck = $scope.stateCheck || $scope.sref;

            //Remove params from state name
            var paramsPos = $scope.stateCheck.indexOf('(');
            if(paramsPos > -1) {
                $scope.stateCheck = $scope.stateCheck.substring(0, paramsPos);
            }

            $rootScope.$on('$stateChangeSuccess', function() {
                $scope.stateName = $scope.$root.currentState;
            });
        }
    }
}]);
